import { Injectable } from '@angular/core';
import { catchAndGetFromFailureRxOp } from '@geekbears/gb-ngrx-stack-base';
import { Actions, createEffect, EffectsModule, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs';
import { RequestsServices } from '../../domain/services/requests.service';
import { RequestsActions } from './requests.actions';

@Injectable()
export class RequestsEffects {
  constructor(
    private actions$: Actions,
    private requestsService: RequestsServices
  ) {}
  allRequests$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RequestsActions.getAllRequests),
      mergeMap((action) => {
        return this.requestsService.getAllRequests(action.companyId).pipe(
          map((response) =>
            RequestsActions.getAllRequestsSuccess({ response })
          ),
          catchAndGetFromFailureRxOp((failure) =>
            RequestsActions.getAllRequestsFailure({ failure })
          )
        );
      })
    );
  });
  createRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RequestsActions.createRequest),
      mergeMap((action) => {
        return this.requestsService.createRequest(action.request).pipe(
          map((requests) => RequestsActions.createRequestSuccess({ requests })),
          catchAndGetFromFailureRxOp((failure) =>
            RequestsActions.createRequestFailure({ failure })
          )
        );
      })
    );
  });
  editRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RequestsActions.editRequest),
      mergeMap((action) => {
        return this.requestsService.editRequest(action.request).pipe(
          map((requests) => RequestsActions.editRequestSuccess({ requests })),
          catchAndGetFromFailureRxOp((failure) =>
            RequestsActions.editRequestFailure({ failure })
          )
        );
      })
    );
  });
  exportRequests$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RequestsActions.exportRequests),
      mergeMap((action) => {
        return this.requestsService.exportRequests(action.request).pipe(
          map((response) =>
            RequestsActions.exportRequestsSuccess({ response })
          ),
          catchAndGetFromFailureRxOp((failure) =>
            RequestsActions.exportRequestsFailure({ failure })
          )
        );
      })
    );
  });
  myRequests$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RequestsActions.myRequests),
      mergeMap((action) => {
        const {type, ...params} = action
        return this.requestsService.myRequests(params).pipe(
          map((response) => RequestsActions.myRequestsSuccess({ response })),
          catchAndGetFromFailureRxOp((failure) =>
            RequestsActions.myRequestsFailure({ failure })
          )
        );
      })
    );
  });
  requestById$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RequestsActions.getRequestById),
      mergeMap((action) => {
        return this.requestsService.getRequestById(action.requestId).pipe(
          map((response) =>
            RequestsActions.getRequestByIdSuccess({ response })
          ),
          catchAndGetFromFailureRxOp((failure) =>
            RequestsActions.getRequestByIdFailure({ failure })
          )
        );
      })
    );
  });

  myRequestsCount$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RequestsActions.getMyRequestsCount),
      mergeMap((action) => {
        return this.requestsService.getMyRequestsCount(action.userId).pipe(
          map((response) =>
            RequestsActions.getMyRequestsCountSuccess({ response })
          ),
          catchAndGetFromFailureRxOp((failure) =>
            RequestsActions.getMyRequestsCountFailure({ failure })
          )
        );
      })
    );
  });
}
export const RequestsEffectsModule = EffectsModule.forFeature([
  RequestsEffects,
]);
